export default "__VITE_ASSET__CFfGCQXR__"